import { v1 as uuid } from 'uuid';
import { Box, FormControl, FormHelperText, makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import moment from 'moment';
import React, { FunctionComponent } from 'react';
import DatePicker from '../../../DatePicker';
import { FormFieldProps } from '../../../FormDisplay/FormFieldDisplay/FormFieldDisplay';

const DatePickerFilterField: FunctionComponent<FormFieldProps> = (props) => {
    const { formField, handleInputChange, value, error } = props;

    const classes = makeStyles(() => ({
        formControl: {
            marginLeft: 15,
            minWidth: 160,
            maxWidth: 160,
        },
        datePickerContainer: {
            backgroundColor: 'white',
            borderRadius: 5,
        },
        inputCustomStyle: {
            fontSize: 16,
        },
    }))();
    const inputClasses = classNames({
        [classes.inputCustomStyle]: true,
    });
    return (
        <Box>
            <FormControl className={classes.formControl}>
                <>
                    <DatePicker
                        containerClasses={classes.datePickerContainer}
                        value={value}
                        inputProps={{
                            classes: {
                                root: inputClasses,
                            },
                        }}
                        error={error?.error}
                        handleDate={(date: string) => {
                            if (date === '') handleInputChange(formField.field, '');
                            else {
                                const momentDate = moment(date);
                                momentDate.isValid() &&
                                    handleInputChange(formField.field, momentDate.format('YYYY-MM-DD'));
                            }
                        }}
                        fullWidth={true}
                        label={formField.label || ''}
                    />
                    {error?.messages?.map((msg) => (
                        <FormHelperText key={uuid()} error={true}>
                            {msg}
                        </FormHelperText>
                    ))}
                </>
            </FormControl>
        </Box>
    );
};

export default DatePickerFilterField;
